import { ProMailDomainStatus } from '../email_hosting';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS = 'PRO_MAIL_DOMAIN_STATUS_';

export const ProMailDomainStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS}${ProMailDomainStatus.PENDING}`]: 'En attente',
    [`${TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS}${ProMailDomainStatus.PROVISIONING}`]: 'Configuration en cours',
    [`${TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS}${ProMailDomainStatus.ACTIVE}`]: 'Actif',
    [`${TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS}${ProMailDomainStatus.ERROR}`]: 'Erreur',
    [`${TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS}${ProMailDomainStatus.DISABLED}`]: 'Désactivé',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  ProMailDomainStatus,
  ProMailDomainStatusTranslation,
  TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS,
  true,
);
